import Vue from 'vue';
import LogRocket from 'logrocket';
import * as Sentry from '@sentry/vue';

Sentry.init({
  Vue,
  dsn: process.env.VUE_APP_SENTRY_DNS,
  tracesSampleRate: 1.0,
});

LogRocket.getSessionURL((sessionURL) => {
  Sentry.configureScope((scope) => {
    scope.setExtra('sessionURL', sessionURL);
  });
});

async function logErrors(err) {
  if (process.env.NODE_ENV === 'production') {
    Sentry.captureException(err);
  } else {
    // eslint-disable-next-line no-console
    console.error(err);
  }
}

export default {
  logErrors,
};
